import classNames from 'classnames';
import { useHelpCenterVideo } from 'hooks/use-help-center-video';
import { useTranslation } from 'hooks/useTranslation';
import { ProductVariation, ProductVariationBase } from 'models/productsReferential';
import { ComponentProps, MouseEventHandler, ReactNode } from 'react';

type Props = {
  product: ProductVariation | ProductVariationBase;
  icon?: ReactNode;
} & ComponentProps<'button'>;

export function ProductVideoButton({ product, icon, onClick, className, ...props }: Props) {
  const label = useTranslation('learnMore.video');
  const { hasVideo, openLearnMore } = useHelpCenterVideo(product.productType, product.productSubType);

  if (!hasVideo) {
    return null;
  }

  const handleClick: MouseEventHandler<HTMLButtonElement> = event => {
    event.stopPropagation();
    onClick?.(event);
    openLearnMore();
  };

  return (
    <button
      onClick={handleClick}
      aria-label={label}
      className={classNames(`btn btn-flat-secondary btn-icon`, className)}
      {...props}
    >
      {icon || (
        <i className="icon" aria-hidden="true">
          play_circle_outline
        </i>
      )}
    </button>
  );
}
